import Swal, {SweetAlertIcon} from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const ReactSwal = withReactContent(Swal)

export interface SwalOptions {
  title: string
  text?: string
  html?: string
  icon?: SweetAlertIcon
  showCancelButton?: boolean
  confirmButtonText?: string
  cancelButtonText?: string
  showConfirmButton?: boolean
  showCloseButton?: boolean
  customConfirmClass?: string
  customCancelClass?: string
  boldTitle?: boolean
}

export function showSwal(options: SwalOptions): Promise<any>
export function showSwal(title: string, text?: string, icon?: SweetAlertIcon): Promise<any>
export function showSwal(
  firstArg: string | SwalOptions,
  secondArg?: string,
  thirdArg?: SweetAlertIcon
): Promise<any> {
  let options: SwalOptions

  if (typeof firstArg === 'string') {
    options = {
      title: firstArg,
      text: secondArg,
      icon: thirdArg,
    }
  } else {
    options = firstArg
  }

  const isQuestionOrWarning = options.icon === 'question' || options.icon === 'warning'
  const icon = options.icon || 'info'
  const showCancelButton =
    options.showCancelButton !== undefined ? options.showCancelButton : isQuestionOrWarning
  const isBoldTitle = options.boldTitle !== undefined ? options.boldTitle : showCancelButton
  const showConfirmButton =
    options.showConfirmButton !== undefined ? options.showConfirmButton : true
  const confirmButtonText = options.confirmButtonText || (isQuestionOrWarning ? 'Yes' : 'OK')
  const cancelButtonText = options.cancelButtonText || (isQuestionOrWarning ? 'No' : 'Cancel')

  let confirmClass = 'btn btn-success btn-sm'
  let notConfirmClass =
    options.icon === 'warning' || options.icon === 'error' || options.icon === 'success'
      ? 'btn-sm'
      : ''
  if (notConfirmClass) {
    confirmClass = 'btn btn-sm'
  }
  confirmClass = options.customConfirmClass || confirmClass
  const cancelClass = options.customCancelClass || 'btn btn-danger btn-sm'

  return ReactSwal.fire({
    title: options.title,
    text: options.text,
    html: options.html,
    icon,
    showCancelButton,
    showConfirmButton,
    showCloseButton: options.showCloseButton || false,
    confirmButtonText,
    cancelButtonText,
    customClass: {
      title: isBoldTitle ? 'fw-bold' : '',
      confirmButton: confirmClass + ' me-2',
      cancelButton: cancelClass,
    },
    didOpen: (popup) => {
      const confirmButton = popup.querySelector('.swal2-confirm') as HTMLElement
      if (confirmButton && notConfirmClass) {
        // SweetAlert's own purple is off-palette; follow the theme's primary.
        const primary =
          getComputedStyle(document.documentElement).getPropertyValue('--bs-primary').trim() ||
          '#3699ff'

        confirmButton.style.backgroundColor = primary
        confirmButton.style.borderColor = primary
        confirmButton.style.color = '#fff'
      }
    },
    buttonsStyling: false,
    padding: '1rem',
  })
}
